// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"1d1c19c1","96":"9ce6ad88","240":"d88aa82c","306":"cc7abdcd","355":"322465ba","549":"13354968","794":"b25238f1"}[chunkId] + ".chunk.js";
};